import Modal from "react-modal";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { requestHandler } from "../../services/requestHandler";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

export default function AddTrackingId({
  showModal,
  setShowModal,
  orderData,
  setDataList,
}) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();
  useEffect(() => {
    if (orderData?.trackingId) setValue("trackingId", orderData?.trackingId);
  }, [showModal]);

  const onSubmit = async (data) => {
    const { trackingId  } = data;
    const response = await requestHandler(
      "PUT",
      "orders/admin/add-trackingid",
      {
        id: orderData?._id,
        trackingId,
      },
      dispatch
    );
    if (response?.status) {
      toast.success(response?.message);
      setShowModal(false);
      reset({ trackingId: "" });
      setDataList((prevState) => {
        if (prevState) {
          return prevState?.map((res) =>
            res._id == orderData?._id ? { ...res, trackingId } : res
          );
        }
      });
    }
  };
  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      className="model_block"
      onRequestClose={() => setShowModal(false)}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Tracking Id : ({ orderData?.orderTrackingUniqueId })</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShowModal(false)}
            >
              <i aria-hidden="true" className="ki ki-close"></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="form-group row my-2">

              {/* <h5 className="mx-4 my-3">Order Tracking ID :  {orderData?.orderTrackingUniqueId}</h5> */}
              <div className="col-12">
                <label
                  className="w-100 font-size-h6 text-dark-75 font-weight-bolder"
                  style={{ textAlign: "left" }}
                >
                  Add AWB URL.
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  placeholder="AWB No."
                  name="trackingId"
                  {...register("trackingId", { required: true })}
                />
              </div>
              {errors.trackingId?.type === "required" && (
                <div
                  className="invalid-feedback ml-4"
                  style={{ textAlign: "left" }}
                >
                  The field is required.
                </div>
              )}
              <div className="col-12 mt-2" style={{ textAlign: "left" }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </button>
              </div>
            </div>
            <div className="clearfix">&nbsp;</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
